<template>
  <section
    class="Modal ModalLogin"
    v-if="showModal"
    :class="{ display: showModal }"
    ref="calendar"
  >
    <div class="Modal-header">
      <span @click="closeModal">fermer</span>
      <div class="Modal-close" @click="closeModal">
        <svg v-svg symbol="Close" size="0 0 16 16" role="presentation" class="icon--inline"></svg>
      </div>
    </div>
    <div class="Modal-inner">
      <div class="Modal-content">
        <div class="Modal-logo">
          <img
            v-if="isZeborne"
            :src="baseUrlMedia+'/skin/frontend/mib/default/images/logo.svg'"
            alt="Zeborne"
          />
          <img
            v-else
            :src="baseUrlMedia+'/skin/frontend/mcp/default/images/logo.svg'"
            alt="Mon Chauffagiste Privé"
          />
        </div>
        <div class="Modal-title">
          <p v-if="accountExist">Il semble que vous avez déjà un compte. </br>
          </p>
          <span class="tilte-info color-primary">Si c'est votre première commande, cliquez sur "mot de passe oublié" pour créer votre compte </span>
          <span class="tilte-info">sinon connectez-vous à votre compte</span>
        </div>
        <!-- Email -->
        <form name="formLogin" @submit.prevent="login(shouldReload)">
          <div class="FormRow FormColumn">
            <form-wrapper :validator="$v.formValidations">
              <form-group name="emailLogin">
                <div 
                  class="FormRow-input Form-inputText"
                  :class="{ validate: !$v.formValidations.emailLogin.$invalid }"
                >
                  <input
                    type="email"
                    name="emailLogin"
                    autocomplete="email"
                    ref="emailLogin"
                    id="emailLogin"
                    class="topLabel"
                    required
                    
                    @input="$v.formValidations.emailLogin.$touch()"
                    v-model.trim="formValidations.emailLogin"
                  />
                  <label for="emailLogin">Email*</label>
                </div>
              </form-group>
            </form-wrapper>
            <form-wrapper :validator="$v.formValidations">
              <form-group name="password">
                <div class="FormRow-input Form-inputText">
                  <input
                    type="password"
                    name="password"
                    autocomplete="current-password"
                    id="password"
                    class="topLabel"
                    required
                    
                    @input="$v.formValidations.password.$touch()"
                    v-model.trim="formValidations.password"
                  />
                  <label for="password">Mot de passe *</label>
                </div>
              </form-group>
            </form-wrapper>
          </div>
          <div class="Modal-link">
            <a :href="forgotPasswordUrl">Mot de passe oublié ?</a>
          </div>
          <button type="button" @click="login(shouldReload)" class="Button " :class="isZeborne ? 'Button-danger' : 'Button-primary'">Se connecter</button>
        </form>
        <!-- Error Message -->
        <Messages
          v-for="(errorMessage, index) in errorMessages"
          :text="errorMessage"
          :key="index"
          :type="'danger'"
        ></Messages>
      </div>
    </div>
  </section>
</template>

<script>
import TopLabelMixin from "@/mixins/topLabelMixin";
import loginMixin from "@/mixins/actions/account/loginMixin";
import formValidationMixin from "@/mixins/actions/validation/formValidationMixin";

import "@/components/Modal/Modal.scss";
import { mapGetters } from 'vuex';

export default {
  name: "ModalLogin",
  mixins: [TopLabelMixin, loginMixin, formValidationMixin],

  props: {
    showModal: Boolean,
    accountExist: Boolean,
    content: String,
    emailProps: {
      type: String,
      required: false,
      default: "",
    },
    shouldReload: {
      type: Boolean,
      default: true,
    }
  },

  computed: {
    ...mapGetters({ storeId: "getStoreId" }),
    ...mapGetters({ isZeborne: "isZeborne"}),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),

  },

  methods: {
    closeModal () {
      return this.$emit("LoginModal::close");
    },

  },

  data () {
    return {
      forgotPasswordUrl: process.env.VUE_APP_API_BASE_URL + '/customer/account/forgotpassword/',
      baseUrlMedia: process.env.VUE_APP_API_BASE_URL,
    };
  },


  mounted () {
    const target = this.$refs.emailLogin;
    target.value = this.emailProps;
    this.formValidations.emailLogin = this.emailProps;
    this.forgotPasswordUrl = process.env.VUE_APP_API_BASE_URL + this.storeUrlPrefix + '/customer/account/forgotpassword/';
  },
};
</script>
